import React from 'react'
import Head from 'next/head'
import initFacebookSDK from './functions/initSDK'

const HOST = process.env.NEXT_PUBLIC_HOST

class FacebookLike extends React.Component {
    componentDidMount () {
        const initialized = initFacebookSDK()
        if (!initialized) {
            setTimeout(initFacebookSDK, 500)
        }
    }

    render () {
        const { url, text } = this.props
        const href = `${HOST}${url}`
        const wrapperStyle = {display:'flex',flexWrap:'wrap',gap:5,justifyContent:'flex-start',marginTop:26,overflow:'hidden'}

        return (
            <div style={wrapperStyle}>
                {this.linkSDK()}
                <div className="fb-share-button"
                    data-href={href}
                    data-layout="button_count"
                    data-size="large">
                        <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
                            className="fb-xfbml-parse-ignore">

                            {text}
                        </a>
                </div>
                <div className="fb-like"
                    data-href={href}
                    data-width=""
                    data-layout="standard"
                    data-action="like"
                    data-size="large"
                    data-share="false">
                </div>
                <br />
            </div>
        )
    }

    // This requires whole Facebook SDK to be loaded.
    linkSDK = () => <Head>
        <script
            async
            crossOrigin="anonymous"
            defer
            key="spl-facebook-sdk"
            nonce="FOKrbAYI"
            src="https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v11.0&appId=2561398784175766&autoLogAppEvents=1" />
    </Head>
}

export default FacebookLike